import GroupRegister from "./GroupRegister";
import GroupList from "./GroupList";
import { useState } from "react";
import MultiManual from "../../components/Manual/MultiManual";

export default function Group() {

  const [refresh, setRefresh] = useState(true);

  return (
    <>
      <GroupRegister refresh={refresh} setRefresh={setRefresh} />


      <hr style={{ margin: '20px' }}></hr>

      <GroupList refresh={refresh} setRefresh={setRefresh} />

      <MultiManual
          components={[
            {
              id: 'form-inputs',
              message: 'Você pode preencher este formulário com os dados de um novo grupo',
              rect: { height: 20, top: -20 }
            },
            {
              id: 'register-button',
              message: 'Aperte o botão para confirmar o cadastro',
              rect: { height: 20, top: -20 }
            },
            {
              id: 'groups-list',
              message: 'Aqui é a lista de grupos',
              rect: { height: 20, top: -20 }
            }

          ]}
        />
    </>
  )
}